import * as COMPONENT from '@Components';
import '@Styles/about.css';

const About = () => {
  return (
    <div className='container'>
      <COMPONENT.AboutHistory />
      <COMPONENT.AboutTeam />
    </div>
  );
}

export default About;